module.exports = __webpack_public_path__ + "images/day.1e91fdf36873a727f84f926d0eb5f3d3.png";